import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../api/marvarApi"
import { onLogout } from "store"

const useFetchGarantias = () => {

    const dispatch = useDispatch()

    const { permissionActive } = useSelector(state => state.permission)

    const getGarantias = async() => {

        const token = localStorage.getItem('token')

        if (!token) return dispatch(onLogout())

        try {
            const { data } = await marvarApi.get('/garantias')
            return data.data
        } catch (e) {
            return null
        }
    }

    const getGarantia = async (idgarantia) => {
        const token = localStorage.getItem('token')

        if (!token) return dispatch(onLogout())

        try {
            const { data } = await marvarApi.get(`/garantias/${idgarantia}`)
            return data.data
        } catch (e) {
            return null
        }

    }

    const createGarantia = async({ idcliente, tipo_garantia, fecha_recepcion, vehiculo_placa, vehiculo_color, vehiculo_modelo, vehiculo_marca, descripcion_corta, descripcion_larga, valor_garantia, usuario_creo, fecha_creo }) => {
        const token = localStorage.getItem('token')

        if (!token) return dispatch(onLogout())

        try {
            const { data } = await marvarApi.post('/garantias/create', {
                idcliente,
                tipo_garantia,
                fecha_recepcion,
                vehiculo_placa,
                vehiculo_color,
                vehiculo_modelo,
                vehiculo_marca,
                descripcion_corta,
                descripcion_larga,
                valor_garantia,
                usuario_creo,
                fecha_creo
            })
            return data.data
        } catch (e) {
            return null
        }

    }

    const updateGarantia = async({ idgarantia, idcliente, tipo_garantia, fecha_recepcion, vehiculo_placa, vehiculo_color, vehiculo_modelo, vehiculo_marca, descripcion_corta, descripcion_larga, valor_garantia, usuario_modifico, fecha_modifico }) => {
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const { data } = await marvarApi.put(`/garantias/update/${idgarantia}`, {
                idcliente,
                tipo_garantia,
                fecha_recepcion,
                vehiculo_placa,
                vehiculo_color,
                vehiculo_modelo,
                vehiculo_marca,
                descripcion_corta,
                descripcion_larga,
                valor_garantia,
                usuario_modifico,
                fecha_modifico
            })
            return data.data
        } catch (e) {
            return null
        }
    }

    const enableGarantia = async({ idgarantia }) => {
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const { data } = await marvarApi.put(`/garantias/enable/${idgarantia}`)
            return data.data
        } catch (e) {
            return null
        }
    }

    const disableGarantia = async({ idgarantia }) => {
        const token = localStorage.getItem('token')

        if (!token) return dispatch(onLogout())
        try {
            const { data } = await marvarApi.put(`/garantias/disable/${idgarantia}`)
            return data.data
        } catch (e) {
            return null
        }
    }

    const deleteGarantia = async({ idgarantia }) => {
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const { data } = await marvarApi.delete(`/garantias/delete/${idgarantia}`)
            return data.data
        } catch (e) {
            return null
        }
    }

    //Función especial para extraer a los clientes y llenar select
    const getClientes = async() => {

        const token = localStorage.getItem('token')

        if (!token) return dispatch(onLogout())

        try {
            const { data } = await marvarApi.get('/garantias/get-clientes')
            return data.data
        } catch (e) {
            return null
        }
    }

    //Función para insertar el detalle de filas al seleccionar Bien Inmueble como garantía
    const createDetalleGarantiaBienInmueble = async({ idgarantia, finca, folio, libro, departamento }) => {
        const token = localStorage.getItem('token')

        if (!token) return dispatch(onLogout())

        try {
            const { data } = await marvarApi.post('/garantias/create-detalle-bien-inmueble', {
                idgarantia,
                finca,
                folio,
                libro,
                departamento,
            })
            return data.data
        } catch (e) {
            return null
        }

    }

    //Función para insertar el detalle de vehículos al seleccionar vehículo como garantía
    const createDetalleVehiculo = async({ idgarantia, placa, color, modelo, marca }) => {
        const token = localStorage.getItem('token')

        if (!token) return dispatch(onLogout())

        try {
            const { data } = await marvarApi.post('/garantias/create-detalle-vehiculo', {
                idgarantia,
                placa,
                color,
                modelo,
                marca,
            })
            return data.data
        } catch (e) {
            return null
        }

    }

    const deleteDetalleBienInmueble = async({ idgarantia }) => {
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const { data } = await marvarApi.delete(`/garantias/delete-detalle-bien-inmueble/${idgarantia}`)
            return data.data
        } catch (e) {
            return null
        }
    }

    const deleteDetalleVehiculo = async({ idgarantia }) => {
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const { data } = await marvarApi.delete(`/garantias/delete-detalle-vehiculo/${idgarantia}`)
            return data.data
        } catch (e) {
            return null
        }
    }

    const getDetalleBienInmueble = async(idgarantia) => {

        const token = localStorage.getItem('token')

        if (!token) return dispatch(onLogout())

        try {
            const { data } = await marvarApi.get(`/garantias/get-detalle-bien-inmueble/${idgarantia}`)
            return data.data
        } catch (e) {
            return null
        }
    }

    const deleteUnSoloDetalleBienInmueble = async({ iddetallebieninmueble }) => {
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const { data } = await marvarApi.delete(`/garantias/delete-unico-detalle-bien-inmueble/${iddetallebieninmueble}`)
            return data.data
        } catch (e) {
            return null
        }
    }

    return {
        getGarantias,
        createGarantia,
        getGarantia,
        permissionActive,
        updateGarantia,
        enableGarantia,
        disableGarantia,
        deleteGarantia,
        getClientes,
        createDetalleGarantiaBienInmueble,
        createDetalleVehiculo,
        deleteDetalleBienInmueble,
        deleteDetalleVehiculo,
        getDetalleBienInmueble,
        deleteUnSoloDetalleBienInmueble
    }
}

export {
    useFetchGarantias
}